function NotFound() {
  return (
    <div className="text-center">
      <h2>404 Error: Page Not Found</h2>
      <img src="https://media.giphy.com/media/3o7aTskHEUdgCQAXde/giphy.gif" alt="confused john travolta" />
    </div>
  )
}

export default NotFound;